// @ts-nocheck
import React from 'react';
import Users from 'components/access/Users';

const PenlyAccessUsers = () => (
    <Users />
);

export default PenlyAccessUsers;
